import Uri from "jsuri";
import type {
	ICardOrderItem,
	IDashboardPreferences,
	IPartnerInfo,
	ProductScoreResponse,
} from "../constants/apiconstants-pfs";
import Env from "../utils/env";
import { deleteUri, getUri, putUri } from "../utils/fetch";
import { getTaticIdObj } from "../utils/getTaticObj";

export const getLoggedinPartnersInfo = (
	includeTechPartnerOnBoarding?: boolean,
	abortSignal?: AbortSignal,
): Promise<IPartnerInfo> => {
	const additionalParams: RequestInit = {};
	const uri = new Uri(`${Env.hydraAPIURL}/pfs/ps/partners/current`);
	if (includeTechPartnerOnBoarding) {
		uri.addQueryParam("includeTechPartnerOnBoarding", includeTechPartnerOnBoarding);
	}
	if (abortSignal) {
		Object.assign(additionalParams, { signal: abortSignal });
	}
	const taticData = getTaticIdObj();
	if (Object.keys(taticData).length > 0) {
		const taticHeaders: HeadersInit = {
			...(taticData?.internalTacticId && { "x-rh-omni-itc": taticData.internalTacticId }),
			...(taticData?.externalTacticId && { "x-rh-omni-tc": taticData.externalTacticId }),
			...(taticData?.personalizationTacticId && { "x-rh-omni-pc": taticData.personalizationTacticId }),
		};
		Object.assign(additionalParams, { headers: taticHeaders });
	}
	return getUri(uri, additionalParams);
};

export const getDashboardPreferences = (abortSignal?: AbortSignal): Promise<IDashboardPreferences> => {
	const uri = `${Env.hydraAPIURL}${Env.pfsPSPrefix}/users/dashboard/preferences`;
	const additionalParams: RequestInit = {};
	if (abortSignal) {
		Object.assign(additionalParams, { signal: abortSignal });
	}
	return getUri(uri, additionalParams);
};

export const saveDashboardPreferences = (
	cards: Pick<ICardOrderItem, "cardTypeCode">[],
): Promise<IDashboardPreferences> => {
	const uri = `${Env.hydraAPIURL}${Env.pfsPSPrefix}/users/dashboard/preferences`;
	return putUri(uri, { cards });
};

export const resetDashboardPreferences = (): Promise<IDashboardPreferences> => {
	const uri = `${Env.hydraAPIURL}${Env.pfsPSPrefix}/users/dashboard/preferences`;
	return deleteUri(uri);
};

export const getProductScoreStatus = (id: string, abortSignal?: AbortSignal): Promise<ProductScoreResponse> => {
	const uri = `${Env.hydraAPIURL}/pfs/cs/product-listings/id/${id}/score`;
	const additionalParams: RequestInit = {};
	if (abortSignal) {
		Object.assign(additionalParams, { signal: abortSignal });
	}
	return getUri(uri, additionalParams);
};
